<template>
  <b-modal
    v-if="!$device.isMobile"
    content-class="rounded-10 position-relative"
    size="sm"
    :visible="visible"
    centered
    hide-footer
    hide-header-close
    @hide="close"
    @close="close"
  >
    <template #modal-title>
      <h3>{{ title }}</h3>
      <i class="icon-X" @click="close"></i>
    </template>

    <div class="main-content">
      <div class="inner-content hidden-scroll-all">
        <component :is="component" :student="student" />
      </div>
    </div>

    <template #modal-footer><span></span></template>
  </b-modal>

  <div v-else v-show="visible" class="page">
    <BaseHeader
      v-show="$device.isMobile"
      :title="title"
      mode="secondary"
      :is-title-bold="true"
      left-arrow
      :back-on-click-left="false"
      @on-click-left="close"
    />
    <div class="main-content hidden-scroll-all">
      <component :is="component" :student="student" />
    </div>
  </div>
</template>

<script>
import BaseHeader from '@/components/Base/BaseHeader.vue';
import TaskCaption from '@/components/TeacherManagement/TaskCaption.vue';
import ScoreCaption from '@/components/TeacherManagement/ScoreCaption.vue';
import {CAPTION_TYPE} from '@/constant/teacherManagement';
import studentInfoMixin from '@/mixin/studentInfo.js';

export default {
  mixins: [studentInfoMixin],
  components: {
    BaseHeader,
    TaskCaption,
  },
  computed: {
    tabs() {
      return [
        {
          text: this.$t('學習任務'),
          mobile: this.$t('學習任務'),
          value: CAPTION_TYPE.TASK,
          component: TaskCaption,
        },
        {
          text: this.$t('評分系統'),
          mobile: this.$t('評分系統說明'),
          value: CAPTION_TYPE.SCORE,
          component: ScoreCaption,
        },
      ];
    },
    title() {
      const tab = this.tabs.find(
        (tab) => tab.value === this.showManagementCaptionType
      );
      return this.$device.isMobile ? tab?.mobile : tab?.text;
    },
    component() {
      const tab = this.tabs.find(
        (tab) => tab.value === this.showManagementCaptionType
      );
      return tab?.component;
    },
    showManagementCaptionType() {
      return this.$store.state.teacherManagement.showManagementCaptionType;
    },
    student() {
      return this.$store.state.teacherManagement.showManagementCaptionStudent;
    },
    visible() {
      return !!this.showManagementCaptionType;
    },
  },
  methods: {
    close() {
      this.$store.commit('teacherManagement/setShowManagementCaptionType', {
        type: null,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-X {
  position: absolute;
  font-size: 32px;
  right: 16px;
  top: 12px;
  color: #ff855e;
  cursor: pointer;
}
.page {
  width: 100%;
  height: 100%;
  background: $bgcontainer;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6;
  .main-content {
    max-height: calc(100% - 56px);
    overflow-y: auto;
    margin: 0;
  }
}
:deep() .modal-dialog {
  min-width: 616px;
  margin: 0.5rem auto;
}
.mc-type-modal {
  text-align: center;
}
:deep() {
  .modal-footer {
    justify-content: center;
  }
  .modal-body {
    padding: 0;
    border-radius: 10px;
    overflow: hidden;
  }
}

.main-content {
  margin: $spacing-s;
  background: $white;
  .inner-content {
    border: 1px solid $line-2;
    border-radius: 10px;
    max-height: 373px;
    overflow-y: auto;
  }
}
</style>
